// User management types

export type UserRole = 'viewer' | 'analyst' | 'org_admin' | 'system_admin'

export interface User {
  id: string
  organization_id: string
  email: string
  full_name: string
  role: UserRole
  has_all_customer_access: boolean
  is_active: boolean
  created_at: string
  updated_at: string
  last_login: string | null
  created_by: string | null
}

export interface UserCustomerAccess {
  id: string
  user_id: string
  customer_id: string
  organization_id: string
  access_level: 'read' | 'write' | 'admin'
  created_at: string
  created_by: string | null
}

export interface UserInvitation {
  id: string
  email: string
  organization_id: string
  role: UserRole
  has_all_customer_access: boolean
  customer_ids: string[]
  invited_by: string | null
  token: string
  expires_at: string
  accepted_at: string | null
  created_at: string
}

export interface CreateUserRequest {
  email: string
  password: string
  full_name?: string
  role?: UserRole
  has_all_customer_access?: boolean
  customer_ids?: string[]
}

export interface UpdateUserRequest {
  user_id: string
  full_name?: string
  role?: UserRole
  has_all_customer_access?: boolean
  is_active?: boolean
}

export interface ResetPasswordRequest {
  user_id: string
  new_password: string
}

export interface InviteUserRequest {
  email: string
  role?: UserRole
  has_all_customer_access?: boolean
  customer_ids?: string[]
}

export const USER_ROLES: { value: UserRole; label: string; description: string }[] = [
  { value: 'viewer', label: 'Viewer', description: 'Read-only access' },
  { value: 'analyst', label: 'Analyst', description: 'Can edit knowledge base' },
  { value: 'org_admin', label: 'Org Admin', description: 'Full organization control' },
  { value: 'system_admin', label: 'System Admin', description: 'Global system access' },
]
